import { SET_VEHICLES } from './types';

export const setVehicles = (payload) => {
	return {
		payload,
		type: SET_VEHICLES
	};
};
